import { render, staticRenderFns } from "./AddMagazineItem.vue?vue&type=template&id=5a1f2402&scoped=true"
import script from "./AddMagazineItem.vue?vue&type=script&lang=js"
export * from "./AddMagazineItem.vue?vue&type=script&lang=js"
import style0 from "./AddMagazineItem.vue?vue&type=style&index=0&id=5a1f2402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f2402",
  null
  
)

export default component.exports